export const extras = [
  {
    'label': 'Seat Preferences',
    'fieldName': 'seatPreference',
    'options': [
      {'label': 'Aisle seat', 'value': 'aisle'},
      {'label': 'Middle seat', 'value': 'middle'},
      {'label': 'Window seat', 'value': 'window'}
    ]
  },
  {
    'label': 'Meal Preferences',
    'fieldName': 'mealPreference',
    'options': [
      {'label': 'Veg Hindu', 'value': 'veg-hindu'},
      {'label': 'Baby Meal', 'value': 'baby-meal'},
      {'label': 'Bland', 'value': 'bland'},
      {'label': 'Child', 'value': 'child'},
      {'label': 'Diabetic', 'value': 'diabetic'},
      {'label': 'Non-UA Fruit Pltr', 'value': 'non-ua-fruir-pltr'},
      {'label': 'Hindu', 'value': 'hindu'},
      {'label': 'Kosher', 'value': 'kosher'},
      {'label': 'Low Calorie', 'value': 'low-calorie'},
      {'label': 'Low Fat', 'value': 'low-fat'},
      {'label': 'Low Sodium', 'value': 'low-sodium'},
      {'label': 'Moslem', 'value': 'moslem'},
      {'label': 'Low Lactose', 'value': 'low-lactose'},
      {'label': 'Veg Raw', 'value': 'veg-raw'},
      {'label': 'Seafood', 'value': 'seafood'},
      {'label': 'Veg Vegan', 'value': 'veg-vegan'},
      {'label': 'Veg Jain', 'value': 'veg-jain'},
      {'label': 'Veg Lacto-ovo', 'value': 'veg-lacto-ovo'},
      {'label': 'Veg Oriental', 'value': 'veg-oriental'},
      {'label': 'Gluten Free Meal', 'value': 'gluten-free-meal'},
      {'label': 'Special Meal', 'value': 'special-meal'}
    ]
  },
  {
    'label': 'Special Preferences',
    'fieldName': 'specialPreference',
    'options': [
      {'label': 'Passenger is blind', 'value': 'pax-blind'},
      {'label': 'Passenger is deaf', 'value': 'pax-deaf'},
      {'label': 'Wheelchair - with dry cell battery', 'value': 'wc-battery'},
      {'label': 'Wheelchair - cannot ascend\/descend stairs', 'value': 'wc-cannot-walk'},
      {'label': 'Wheelchair - passenger is immobile', 'value': 'wc-immobile'},
      {'label': 'Wheelchair - can walk and ascend\/descend stairs', 'value': 'wc-walk-stairs'}
    ]
  }
]
